import React, {
  Component
} from 'react'
import FirstScreen from './FirstScreen'
import SecondScreen from './SecondScreen'
import ThirdScreen from './ThirdScreen'
import FourthScreen from './FourthScreen'

export class SplashScreen extends Component {
  state = {
    step: 1
  }

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    })
  }

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    })
  }

  render() {
    const {
      step
    } = this.state;
    switch (step) {
      case 1:
        return (<
          FirstScreen
          nextStep={this.nextStep}
        />
        )
      case 2:
        return (
          <SecondScreen
            nextStep={this.nextStep}
            prevStep={this.prevStep}
          />
        )
      case 3:
        return (
          <ThirdScreen
            nextStep={this.nextStep}
            prevStep={this.prevStep}
          />
        )
      case 4:
        return (
          <FourthScreen
            prevStep={this.prevStep}
          />
        )
    }
  }
}

export default SplashScreen